import React, {Component} from 'react';
import DropDown from '../../../../shared/Common/dropDown';
import { ToastContainer, toast } from 'react-toastify';
import ProjectChallenges from '../../ProjectChallenges/ProjectChallenges';
import moment from 'moment';
import './Project.css';

class Project extends Component {
    constructor(props) {
      super(props);
      this.defaultParams = {};
      this.state = {
        openedTool: false,
        settingsDropDown : false,
      };
    }

    componentWillMount = () => {
        let openedToolItem = localStorage.getItem('openedTool');
        if(!openedToolItem && !this.state.openedTool){
            this.props.openProjectChallenges(this.props.projectFullData[0].projectId);
            this.setState({ openedTool : true });
        } else if(openedToolItem && !this.state.openedTool){
            this.props.openProjectChallenges(openedToolItem);
            this.setState({ openedTool : true });
        }
    }

    deleteProject = (id) => {
        this.props.projectDeleted();
        let data = {
            projectId: id
        }
        this.props.deleteProject(data)
    }

    render() {

        return(
            <div className='table-body-row' onClick={  () => this.props.openProjectChallenges(this.props.projectData.projectId) }>
                <div className="table-body-col">{this.props.projectData.projectName}</div>
                <div className="table-body-col">{this.props.projectData.updated_at ? moment(this.props.projectData.updated_at).format('MMMM Do YYYY, h:mm a') : moment(this.props.projectData.createdAt).format('MMMM Do YYYY, h:mm a')}</div>
                <div className="table-body-small-col">
                    <DropDown
                        projectData={this.props.projectData}
                        deleteProject={this.deleteProject}
                        dublicateProject={this.props.dublicateProject}
                        dublicateData={this.props.dublicateData}
                        getProjectsList={this.props.getProjectsList}
                    />
                </div>
                <ProjectChallenges 
                    projectData={this.props.projectData}
                    projectChallengesToggle={this.props.projectChallengesToggle}
                    toolkitsValidation={this.props.toolkitsValidation}
                    toolkitDataChanged={this.props.toolkitDataChanged}
                    toolkitValidationType={this.props.toolkitValidationType}
                    projectId={this.props.projectId}
                />
            </div>
        ) 
    }
}

export default (Project);



// WEBPACK FOOTER //
// ./src/components/Toolkit/ProjectsList/Project/Project.jsx